import mock from "./mock";
import "./db/bulk-upsert-db";

mock.onAny().passThrough();
